import Swiper, { Navigation, Pagination, Lazy, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Lazy, Autoplay]);

export default function setLocals() {
  const locals = document.querySelectorAll('.our-stores');

  locals.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');
    const next = section.querySelector('.swiper-button-next');
    const prev = section.querySelector('.swiper-button-prev');

    new Swiper(carousel, {
      slidesPerView: 3,
      watchOverflow: true,
      preloadImages: false,
      spaceBetween: 20,
      speed: 1000,
      autoplay: {
        delay: 3000,
      },
      lazy: {
        checkInView: true,
        loadPrevNext: false,
        loadOnTransitionStart: true,
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
        disabledClass: '-disabled',
      },
      breakpoints:{
        320:{
          slidesPerView: 1,
        },
        768:{
          slidesPerView: 3,
        }
      }
    });
  });
}
